import { useAssetDetailsContext } from "@/pages/asset-details/context/assetDetailsContext";
import Grid2 from "@mui/material/Grid2";
import { createStyles, makeStyles } from "@mui/styles";
import type { EditableCallbackParams } from "ag-grid-community";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) =>
	createStyles({
		root: {
			"& .ag-icon-menu": {
				display: "none",
			},
			"& .ag-checkbox-input-wrapper": {
				margin: "0 10px",
			},
			"& .ag-cell": {
				alignItems: "center",
				padding: "0 !important",
				backgroundColor: "#FFFF !important",
				border: "unset !important",
			},
			"& .ag-header-cell": {
				padding: "0px !important",
				textAlign: "center !important",
				fontSize: 10,
			},
			"& .ag-root-wrapper": {
				minHeight: "100% !important",
				borderRadius: 3,
				paddingBottom: 45,
			},
			"& .ag-cell-wrapper": {
				width: "95%",
				textAlign: "center",
			},
			"& .ag-body-viewport": {
				borderBottom: "2px solid #DDE2EB",
			},
			"& .ag-menu-option": {
				cursor: "pointer",
			},
		},
		assetLink: {
			color: theme.palette.primary.main,
			cursor: "pointer",
			textDecoration: "none",
			"&:hover": {
				textDecoration: "underline",
			},
		},
	}),
);

type Props = EditableCallbackParams;

const getCompactPath = (fullPath: string) => {
	if (!fullPath) return "";
	const parts = fullPath.split("/");
	if (parts.length <= 3) return fullPath;
	return `${parts[0]}/.../${parts[parts.length - 2]}/${parts[parts.length - 1]}`;
};

export const DocumentAssetNameColumn = ({ data }: Props) => {
	const classes = useStyles();
	const navigate = useNavigate();
	const {
		state: { assetSearchName, assetFullPath, currentGridName, assetSearchId },
	} = useAssetDetailsContext();

	const handleAssetClick = (assetId: string | number) => {
		navigate(
			`/asset-details/${assetId}?resource=${currentGridName}&assets=true&statistics=true&workOrders=true`,
		);
	};

	if (data.id === -1) {
		return (
			<Grid2
				container
				className={classes.root}
				spacing={1}
				style={{ alignItems: "center", justifyContent: "center" }}
			>
				<Grid2 style={{ alignItems: "center", justifyContent: "center" }}>
					{getCompactPath(assetFullPath as string)}
				</Grid2>
			</Grid2>
		);
	} else if (data.id !== -1 && data?.AssetId) {
		const compactPath = getCompactPath(data?.FullPath || "");
		const isCurrentAsset =
			data.AssetId.toString() === assetSearchId?.toString();

		if (isCurrentAsset) {
			return <div title={data?.FullPath}>{compactPath || data?.AssetName}</div>;
		} else {
			return (
				<div
					title={data?.FullPath}
					className={classes.assetLink}
					onClick={() => handleAssetClick(data.AssetId)}
				>
					{compactPath || data?.AssetName}
				</div>
			);
		}
	} else if (data.id !== -1) {
		return <div title={data?.FullPath}>{data?.AssetName}</div>;
	} else return <></>;
};
